/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { IPatient, IPractitioner } from '@ahryman40k/ts-fhir-types/lib/R4';

export interface PatientContextType {
  patient?: IPatient;
  server?: string;
  practitioner?: IPractitioner;
  fhirPatientId?: string;
  mrn?: string;
  fromSmartOnFhir: boolean;
  azureFilename?: string; // Load patient info from azure instead of FHIR
}
export enum SurveyTypes {
  legalDisclaimer = 'LEGAL DISCLAIMER',
  npiPrompt = 'NPI',
  nps = 'SURVEY_NPS',
}
